import { useState, useEffect } from "react";
import { StringerAllocationUI } from "./StringerAllocationUI";

export function StringerAllocationSettings({ settings, setSettings }: { settings: any, setSettings: any }) {
  const [stringers, setStringers] = useState<any[]>([]);
  const API_URL = import.meta.env.VITE_API_URL;

  useEffect(() => {
    // Convert appSettings.stringers (array of strings) to objects with stringingPoints
    // mapping from appSettings.stringerAllocations
    const allocs = settings.stringerAllocations || {};
    const stringersList = (settings.stringers || []).map((s: any) => {
      const name = typeof s === 'string' ? s : s.name;
      return {
        id: name,
        name: name,
        email: typeof s === 'string' ? undefined : s.email,
        stringingPoints: allocs[name] || []
      };
    });
    setStringers(stringersList);
  }, [settings.stringers, settings.stringerAllocations]);

  const handlePointChange = (stringerId: string, point: string) => {
    setStringers(prev => prev.map(s => {
      if (s.id === stringerId) {
        const currentPoints = s.stringingPoints || [];
        const newPoints = currentPoints.includes(point) 
          ? currentPoints.filter((p: string) => p !== point) 
          : [...currentPoints, point];
        return { ...s, stringingPoints: newPoints };
      }
      return s;
    }));
  };

  const handleSave = async () => {
    try {
      const newAllocs: Record<string, string[]> = {};
      stringers.forEach(s => {
        newAllocs[s.name] = s.stringingPoints;
      });

      // Update local state first
      setSettings((prev: any) => ({
        ...prev,
        stringerAllocations: newAllocs
      }));

      const getAuthHeader = () => {
        const token = localStorage.getItem("tt_auth_token");
        const headers: Record<string, string> = {};
        if (token) headers.Authorization = `Bearer ${token}`;
        return headers;
      };

      // We still use the POST endpoint, but we send { stringerAllocations: newAllocs }
      // We will modify the backend to save this to appSettings instead of User table!
      const res = await fetch(`${API_URL}/api/settings/stringer-allocation`, {
        method: "POST",
        headers: {
          ...(getAuthHeader() as any),
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ allocations: stringers })
      });
      if (res.ok) {
        alert("Alocações salvas com sucesso!");
      } else {
        alert("Erro ao salvar no servidor.");
      }
    } catch (err) {
      console.error(err);
      alert("Erro ao salvar.");
    }
  };

  return (
    <StringerAllocationUI
      stringers={stringers}
      availablePoints={settings.pickupPoints || []}
      onPointChange={handlePointChange}
      onSave={handleSave}
      isModal={false}
    />
  );
}
